import type { Theme } from "@/theme/themes";
import type { StyleProp, ViewStyle } from "react-native";

/** Standard bleibt das Label im Rahmen. „above“ setzt es darüber. */
export type FieldLabelPosition = "inset" | "above";

/** Breite nach Inhalt. Ohne Angabe bleibt das Feld wie bisher in der Zeile. */
export type FieldWidth = "weight" | "date" | "full";

export type FieldChromeOptions = {
  labelPosition?: FieldLabelPosition;
  dense?: boolean;
  width?: FieldWidth;
};

export type FieldFrame = {
  above: boolean;
  radius: number;
  paddingH: number;
  paddingV: number;
  /** Oben im Rahmen. Beim bisherigen Label gleich dem Login-Polster. */
  paddingTop: number;
  minHeight: number;
  labelSize: number;
  widthStyle?: ViewStyle;
};

/**
 * Bisherige Login-Maße, solange dense und labelPosition ausbleiben.
 * Dichte Felder nutzen heightDense und radius.control.
 */
export function fieldFrame(theme: Theme, options: FieldChromeOptions = {}): FieldFrame {
  const above = options.labelPosition === "above";
  const dense = options.dense === true;
  const paddingV = dense ? theme.space.dense : theme.control.paddingV;
  return {
    above,
    radius: dense ? theme.radius.control : theme.control.radius,
    paddingH: theme.control.paddingH,
    paddingV,
    paddingTop: above || dense ? paddingV : theme.control.paddingH,
    minHeight: dense ? theme.control.heightDense : theme.control.height,
    labelSize: theme.fontSize.label,
    widthStyle: widthStyle(theme, options.width),
  };
}

function widthStyle(theme: Theme, width: FieldWidth | undefined): ViewStyle | undefined {
  if (width === "weight") {
    return { width: theme.layout.fieldWeight, maxWidth: "100%", alignSelf: "flex-start" };
  }
  if (width === "date") {
    return { width: theme.layout.fieldDate, maxWidth: "100%", alignSelf: "flex-start" };
  }
  if (width === "full") {
    return { width: "100%", alignSelf: "stretch" };
  }
  return undefined;
}

export function mergeFieldStyle(
  frame: FieldFrame,
  style?: StyleProp<ViewStyle>,
): StyleProp<ViewStyle> {
  if (!frame.widthStyle) return style;
  return [frame.widthStyle, style];
}
